module.exports = __webpack_public_path__ + "1c6d8645e363c7d0769ab123687e6563.png";